import { TranslationService } from "@/core/services/TranslationService";

export function EmailFilters() {
  return [
    {
      key: "userIds",
      label: TranslationService.translate("common.to"),
      type: "lookup",
      attrs: {
        mode: "tags",
      }, //
      url: "security/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "type",
      label: TranslationService.translate("pages.email.emailType"),
      type: "select",
      options: [
        // { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate(
            "pages.email.emailTypeOption.DOCUMENT_CREATED"
          ),
          value: "DOCUMENT_CREATED",
        },
        {
          label: TranslationService.translate(
            "pages.email.emailTypeOption.DOCUMENT_UPDATED"
          ),
          value: "DOCUMENT_UPDATED",
        },
        {
          label: TranslationService.translate(
            "pages.email.emailTypeOption.DOCUMENT_EXPIRED"
          ),
          value: "DOCUMENT_EXPIRED",
        },
        {
          label: TranslationService.translate(
            "pages.email.emailTypeOption.DOCUMENT_COMPLETED"
          ),
          value: "DOCUMENT_COMPLETED",
        },
        {
          label: TranslationService.translate(
            "pages.email.emailTypeOption.DOCUMENT_DELETED"
          ),
          value: "DOCUMENT_DELETED",
        },
        {
          label: TranslationService.translate(
            "pages.email.emailTypeOption.EVENT_CREATED"
          ),
          value: "SCHEDULED_EVENT",
        },
        {
          label: TranslationService.translate(
            "pages.email.emailTypeOption.EVENT_FORM"
          ),
          value: "EVENT_FORM",
        },
        {
          label: TranslationService.translate(
            "pages.email.emailTypeOption.CREATE_USER"
          ),
          value: "CREATE_USER",
        },
        {
          label: TranslationService.translate(
            "pages.email.emailTypeOption.UPDATE_USER"
          ),
          value: "UPDATE_USER",
        },
        // {
        //   label: TranslationService.translate(
        //     "pages.email.emailTypeOption.USER_STATUS"
        //   ),
        //   value: "USER_STATUS",
        // },
        // {
        //   label: TranslationService.translate(
        //     "pages.email.emailTypeOption.PASSWORD_CHANGE"
        //   ),
        //   value: "PASSWORD_CHANGE",
        // },
        {
          label: TranslationService.translate(
            "pages.email.emailTypeOption.PASSWORD_RESET"
          ),
          value: "PASSWORD_RESET",
        },
      ],
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.pending"),
          value: "PENDING",
        },
        {
          label: TranslationService.translate("common.failed"),
          value: "FAILED",
        },
        {
          label: TranslationService.translate("common.success"),
          value: "SUCCESS",
        },
      ],
    },
  ];
}
export function lookupTableFilters() {
  return [
    {
      key: "lookupIds",
      label: TranslationService.translate("pages.lookup.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "static-data/filter/LOOKUP_NAME",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.startDate"),
      type: "date",
    },
    {
      key: "endDate",
      label: TranslationService.translate("common.endDate"),
      type: "date",
    },
  ];
}

export function EmailBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "emails",
    entityLabel: TranslationService.translate("pages.email.title"),
  };
}

export function lookupDataModelTableFilters() {
  return [
    {
      key: "userIds",
      label: TranslationService.translate("common.createdBy"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.startDate"),
      type: "date",
    },
  ];
}

export function lookupDataModelTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "lookupsData",
    entityLabel: TranslationService.translate("pages.lookup.title"),
  };
}
